import { render } from "./InputSelect.vue?vue&type=template&id=a2baa59a"
import script from "./InputSelect.vue?vue&type=script&lang=js"
export * from "./InputSelect.vue?vue&type=script&lang=js"

import "./InputSelect.vue?vue&type=style&index=0&id=a2baa59a&lang=scss"

import exportComponent from "/app/widget-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__